import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLines20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLines20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.998 5.25a.75.75 0 0 1 .75-.75h14.51a.75.75 0 0 1 0 1.5H2.748a.75.75 0 0 1-.75-.75M1.996 10a.75.75 0 0 1 .75-.75h14.511a.75.75 0 0 1 0 1.5H2.747a.75.75 0 0 1-.75-.75m.752 4a.75.75 0 0 0 0 1.5h14.51a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLines20);
